import React from 'react';

export default () => <input type="hidden" name="qty" value="2 " />;
